var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":require("@/assets/images/img-empty.png")}}),_c('div',{staticClass:"desc"},[_c('span',[_vm._v(_vm._s(_vm.handledText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }